import { CustomVideoPlayer, Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import AudioItem from './AudioItem/AudioItem';

import {
  Image,
  ImageContainer,
  ItemContainer,
  MainContainer,
  ScrollableContainer,
  SectionContainer,
  VideoItemCont,
} from './Files.styles';

type Props = {
  data?: Array<IMediumAttributes> | null;
};

const Files: React.FC<Props> = ({ data: origData }) => {
  //this will remove duicates
  const data = [...new Set(origData)];

  return (
    <MainContainer>
      {data && data.filter((v) => v.medium.file_type.toLocaleLowerCase() === 'image').length > 0 && (
        <SectionContainer>
          <Typography color="primary" fontSize={20}>
            Images
          </Typography>
          <ScrollableContainer>
            {data
              ?.filter((v) => v.medium.file_type.toLocaleLowerCase() === 'image')
              .map((i) => (
                <ImageContainer>
                  <Image src={i.modified_attachment || i.attachment} alt={i.tag_list[0]} />
                  {i.tag_list.length > 0 && <Typography fontSize={14}>{i.tag_list[0]}</Typography>}
                </ImageContainer>
              ))}
          </ScrollableContainer>
        </SectionContainer>
      )}
      {data && data.filter((v) => v.medium.file_type.toLocaleLowerCase() === 'video').length > 0 && (
        <SectionContainer>
          <Typography color="primary" fontSize={20}>
            Videos
          </Typography>
          <ScrollableContainer>
            {data
              ?.filter((v) => v.medium.file_type.toLocaleLowerCase() === 'video')
              .map((i) => (
                <ItemContainer>
                  <VideoItemCont>
                    {/* <VideoItem url={i.attachment} />
                     */}
                    <CustomVideoPlayer url={i.attachment} isSmall />
                  </VideoItemCont>
                  {i.tag_list.length > 0 && <Typography fontSize={14}>{i.tag_list[0]}</Typography>}
                </ItemContainer>
              ))}
          </ScrollableContainer>
        </SectionContainer>
      )}
      {data &&
        data?.filter(
          (v) =>
            v.medium.file_type.toLocaleLowerCase() !== 'video' && v.medium.file_type.toLocaleLowerCase() !== 'image',
        ).length > 0 && (
          <SectionContainer>
            <Typography color="primary" fontSize={20}>
              Other Files
            </Typography>
            <ScrollableContainer>
              {data
                ?.filter(
                  (v) =>
                    v.medium.file_type.toLocaleLowerCase() !== 'video' &&
                    v.medium.file_type.toLocaleLowerCase() !== 'image',
                )
                .map((i) => (
                  <ItemContainer>
                    <AudioItem item={i} />
                  </ItemContainer>
                ))}
            </ScrollableContainer>
          </SectionContainer>
        )}
    </MainContainer>
  );
};

export default Files;
